import React, {useEffect} from "react"
import {useHelpCta, useMessage, useProgress, useRoomParameters, useRoomSetup, useSolution, useSolutionRepository, useLocal} from "../AppContext"
import {apiDataToRoomSetup} from "../Hooks/RoomSetup"
import {LoadIndicator} from "../Components/LoadIndicator"
import {dispatchSolutionLoadedEvent} from "../Hooks/SolutionRepository"
import style from "./LoadScreen.css"

export const LoadScreen = () => {
    const local = useLocal()

    return <div className={style.load}>
        <div>{local.__("aixFOAM 3D-Raumplaner")}</div>
        <LoadIndicator/>
        <div>{local.__("Ressourcen werden geladen")}</div>
    </div>
}

export const LoadRoom = () => {
    const helpCta = useHelpCta()
    const message = useMessage()
    const progress = useProgress()
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const solution = useSolution()
    const solutionRepository = useSolutionRepository()
    const local = useLocal()

    useEffect(() => {

        if(!getCodeFromUrl()) {
            return
        }

        const load = async () => {
            try {
                const loadedRoom = await solutionRepository.load(getCodeFromUrl())
                roomSetup.setRoom(apiDataToRoomSetup(loadedRoom.plannings[0].room, roomParameters.getRoomParameters().interiors))
                solution.setPlannings(loadedRoom.plannings[0].room.id, loadedRoom.plannings)

                setTimeout(() => {
                    unsetCodeFromUrl()
                    helpCta.disable()
                    progress.gotoSolution()
                    dispatchSolutionLoadedEvent()
                }, 100)

            } catch (error) {
                message.showError(local.__(error.message))
            }
        }

        load().finally()

    }, [])

    return <div className={style.load}>
        <div>{local.__("aixFOAM 3D-Raumplaner")}</div>
        <LoadIndicator/>
        <div>{local.__("Raumplan wird Geladen")}</div>
    </div>
}

export const getCodeFromUrl = () => {
    const pattern = new RegExp('^#[a-z0-9]{12}$', 'i')
    if (pattern.test(window.location.hash)) {
        return window.location.hash.substring(1)
    }

    return null
}

const unsetCodeFromUrl = () => {
    history.replaceState(null, document.title, window.location.pathname + window.location.search)
}